import React from 'react';
import {
   ActivityIndicator,
   Modal,
   View,
   StyleSheet,
   Platform,
} from 'react-native';
import {Popup} from '../components/popup';
import {isWindows} from './utils';

export const ProgressDialog = ({visible}) => {
   return (
      <>
         {Platform.OS === 'windows' ? (
            <Popup
               isOpen={visible}
               isLightDismissEnabled={true}
               onDismiss={() => {}}>
               <View style={styles.modalBackground}>
                  <View style={styles.activityIndicatorWrapper}>
                     <ActivityIndicator size={'large'} animating={visible} />
                  </View>
               </View>
            </Popup>
         ) : (
            <Modal transparent animationType="none" visible={visible}>
               <View style={styles.modalBackground}>
                  <View style={styles.activityIndicatorWrapper}>
                     <ActivityIndicator size={'large'} animating={visible} />
                  </View>
               </View>
            </Modal>
         )}
      </>
   );
};
const styles = StyleSheet.create({
   modalBackground: {
      flex: 1,
      justifyContent: 'center',
      alignItems: 'center',
      backgroundColor: isWindows ? 'rgba(0, 0, 0, 0)' : 'rgba(0, 0, 0, 0.5)', // Semi-transparent black background
   },
   activityIndicatorWrapper: {
      backgroundColor: 'rgba(0, 0, 0, 0',
      padding: 20,
      borderRadius: 10,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
   },
   loadingText: {
      marginTop: 10,
   },
});
